<template>
  <DeleteUserModal />
  <CreateUserModal />
  
  <div class="row mb-4">
    <div class="d-flex">

      <router-link to="/installation" class="text-decoration-none d-flex font-14 me-3 text-black">
        <i class="flaticon-left-arrow lh-1 me-8 position-relative top-1"></i>
        <h5>Voltar</h5>
      </router-link>

    </div>
  </div>
  
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <div class="d-sm-flex align-items-center">
          <h4 class="mb-0">Usuários</h4>
      </div>

      <div v-if="getConfigurations.adm" class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none ms-0"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateUserModal"
        >
          Criar novo usuário
          <i class="flaticon-user-1 position-relative ms-5 fs-14"></i>
        </a>
      </div>
    </div>



    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Nome
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Celular
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Telefone comercial
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                email
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Ativar / Inativar
              </th>
            </tr>
          </thead>
          <tbody>


            <tr v-for="(value, key) in getUsersForCompanyId" :key="key">
              
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ value.name }}
                  </div>
                </div>
              </th>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ applyMaskPhone(value.cell_phone) }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ applyMaskPhone(value.commercial_phone) }}
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.email }}
              </td>
              
              <td :class="{'active-column': value.active, 'inactive-column': !value.active}" class="shadow-none lh-1 fw-medium text-black-emphasis">
                <i :class="{'ph ph-x-circle': !value.active, 'ph ph-check-circle': value.active}" class=" lh-1 position-relative top-1 fs-16"></i>
                {{ value.active == 1 ? 'Ativo' : 'Inativo' }}
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-center pe-0 d-flex justify-content-end">

                <button :class="{'inactive': value.active, 'active': !value.active}" v-on:click="setCurrentDeleteUser(value)" data-bs-toggle="modal" data-bs-target="#DeleteUserModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <span v-if="value.active">Inativar</span>
                  <span v-else>Ativar</span>
                </button>
                
              </td>

            </tr>
          
          
          
          
          </tbody>
        </table>
      </div>
    </div>








  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import DeleteUserModal from './DeleteUserModal.vue';
import CreateUserModal from './CreateUserModal.vue';

export default defineComponent({
  name: "UsersList",
  computed: {
    ...mapGetters([
      'getUsersForCompanyId',
      'getConfigurations'
    ])
  },
  components: {
    DeleteUserModal,
    CreateUserModal
  },
  methods: {
    ...mapActions([
      "setCurrentDeleteUser",
      "setUsersForCompanyId"
    ]),
    applyMaskPhone(value) {
      value = value.replace(/\D/g, '');

      if (value.length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      return value;
    },
  }
});
</script>

<style scoped>
.inactive {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  border-radius: 5px !important;
  background-color: red !important;
  color: #fff !important;
  font-weight: bold;
}

.active {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  border-radius: 5px !important;
  background-color: #06B48A !important;
  color: #fff !important;
  font-weight: bold;
}

.inactive-column {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  background-color: red !important;
  color: #fff !important;
  font-weight: bold;
}

.active-column {
  font-size: 10pt !important;
  padding: 5px 10px !important;
  background-color: #06B48A !important;
  color: #fff !important;
  font-weight: bold;
}
</style>